// import { Hostname } from "@kvix/shared";
import { makeStyles } from "@material-ui/core";
import React from "react";
import { LoginWithAppleButton, LoginWithFacebookButton, LoginWithGoogleButton } from "../Inputs";
export const SocialOauthButtons = ({ text, origin, type, host }) => {
    const useStyles = makeStyles((theme) => ({
        socialButtonsContainer: {
            display: "flex",
            flexDirection: type === 'register' ? "row" : "column",
            justifyContent: "flex-start",
            gap: "8px",
            width: "100%",
            fontSize: 16,
            fontWeight: 600,
            lineHeight: "26px",
            paddingBottom: "8px"
        }
    }));
    const classes = useStyles();
    const loginUrl = (provider, type, origin) => {
        const redirectPath = `?redirectPath=${origin ? origin : "/"}`;
        const url = `/auth/${provider}/${type}` + redirectPath;
        return `${host}${url}`;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.socialButtonsContainer },
            React.createElement(LoginWithGoogleButton, { variant: "big", href: loginUrl("google", type, origin), actionText: `${text ? text : 'Google'}`, type: type }),
            type === 'login' &&
                React.createElement(LoginWithFacebookButton, { variant: "big", href: loginUrl("facebook", type, origin), actionText: `${text ? text : 'Facebook'}` }),
            React.createElement(LoginWithAppleButton, { variant: "big", href: loginUrl("apple", type, origin), actionText: `${text ? text : 'Apple'}`, type: type }))));
};
//# sourceMappingURL=SocialOauthButtons.js.map